module.exports = __webpack_public_path__ + "img/a5559b8d0cc84ca8a9a34e29a7f5c5a4.png";